import { render, staticRenderFns } from "./customerSelect.vue?vue&type=template&id=b88d3e90&scoped=true"
import script from "./customerSelect.vue?vue&type=script&lang=js"
export * from "./customerSelect.vue?vue&type=script&lang=js"
import style0 from "./customerSelect.vue?vue&type=style&index=0&id=b88d3e90&prod&lang=scss&scoped=true"
import style1 from "./customerSelect.vue?vue&type=style&index=1&id=b88d3e90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88d3e90",
  null
  
)

export default component.exports